import { Route } from '@angular/router';
import { PDSMainNavigationComponent } from '@peca/design-system';
import { KeycloakAuthComponent, keycloakGuard } from '@peca/keycloak';

import { MONITORING_ROUTES } from './modules/monitoring/monitoring.routes';
import { queryRoutes } from './modules/query/query.routes';
import { SEARCH_ROUTES } from './modules/search/search.routes';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    component: KeycloakAuthComponent,
  },
  {
    path: '',
    component: PDSMainNavigationComponent,
    canActivate: [keycloakGuard([])],
    children: [
      {
        path: 'query',
        children: queryRoutes,
      },
      {
        path: 'busca',
        children: SEARCH_ROUTES,
      },
      {
        path: 'monitoramento',
        children: MONITORING_ROUTES,
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'query',
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'query',
  },
];
